import { Grid, Skeleton, Typography, Box } from "@mui/material";
import { getLitters } from "../services";
import { useWpFetch } from "../hooks/useWpFetch";
import { useNavigate } from "react-router";
import { LitterCard } from "../components/LitterCard/LitterCard";

const Litters = () => {
  const { data: litters, loading } = useWpFetch(() => getLitters(), [], []);
  const navigate = useNavigate();

  return (
    <Box className="article-main">
      <Typography
        variant="h4"
        sx={{
          fontFamily: '"Cinzel", serif',
          color: "#4a3728",
          borderBottom: "2px solid #d4b483",
          pb: 1,
          mb: 2,
        }}
      >
        Our Puppies
      </Typography>
      <Typography variant="body1" sx={{ color: "#6b5b4a", mb: 3 }}>
        Here you can find information about our puppies.
      </Typography>
      <Grid container spacing={3}>
        {loading
          ? [1, 2, 3].map((i) => (
              <Grid size={12} key={i}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Skeleton
                    variant="rectangular"
                    width={180}
                    height={180}
                    sx={{ borderRadius: 2, flexShrink: 0 }}
                  />
                  <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="50%" height={32} />
                    <Skeleton variant="text" width="90%" />
                    <Skeleton variant="text" width="70%" />
                    <Skeleton variant="text" width="40%" />
                  </Box>
                </Box>
              </Grid>
            ))
          : litters.map((litter: any) => {
              return (
                <Grid size={12} key={litter.id}>
                  <LitterCard
                    {...litter}
                    description={litter.excerpt?.rendered || ""}
                    onNavigate={() =>
                      navigate(`/puppies/${litter.id}`, {
                        state: { name: litter.name },
                      })
                    }
                  />
                </Grid>
              );
            })}
      </Grid>
    </Box>
  );
};

export default Litters;
